/**
 * 사운드 그룹 — 글로벌·로컬 사이 중간 단계 볼륨 가중치.
 *
 * - `bgm`: 배경 음악 (단일 슬롯, loop 기본 true)
 * - `sfx`: 게임플레이 효과음 (이벤트 성공/실패·결과 등)
 * - `ui`: UI 인터랙션 효과음 (버튼 클릭·모달 열기 등)
 *
 * 신규 그룹 추가 시 union + `SOUND_CATEGORIES` 배열만 확장.
 * SettingsView 슬라이더·다국어 라벨도 같이 보강해야 사용자에게 노출된다.
 */
export type SoundCategory = "bgm" | "sfx" | "ui";

export const SOUND_CATEGORIES: readonly SoundCategory[] = ["bgm", "sfx", "ui"];

export function isSoundCategory(value: string): value is SoundCategory {
  return (SOUND_CATEGORIES as readonly string[]).includes(value);
}
